import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { searchAlertsBannerResourceDefinition } from '../utils/queryDefinitions';
import useSearchLocationParams from './useSearchLocationParams';

export interface SearchAlertsMapBanner {
  /** The map banner replaces the plain alerts banner's content. */
  isShown: boolean;
  isLoading: boolean;
  /** Breeders of the breed within 250 miles of the search. */
  breederCount: number | null;
  /** Center of the search, for the map. */
  latitude: number | null;
  longitude: number | null;
  /** "Brooklyn, NY" for a zip search; null when the search already has a name. */
  locationName: string | null;
}

/**
 * The map alerts banner's data. Pass `isEligible` false where the map
 * banner can't show, so its region isn't fetched.
 */
export default function useSearchAlertsMapBanner(
  isEligible: boolean
): SearchAlertsMapBanner {
  const { breedSlug } = useSelector(({ server }: any) => server);
  const locationParams = useSearchLocationParams();

  const {
    isLoading,
    value: {
      data: {
        breeder_count: breederCount,
        latitude,
        longitude,
        location_name: locationName
      }
    }
  } = useResourceQuery({
    ...searchAlertsBannerResourceDefinition(breedSlug, locationParams),
    enabled: isEligible
  });

  // A location the server can't place has no map to draw; the plain banner
  // shows instead.
  const hasRegion = latitude !== null && longitude !== null;

  return {
    isShown: isEligible && (isLoading || hasRegion),
    isLoading,
    breederCount,
    latitude,
    longitude,
    locationName
  };
}
